import { Box, TableCell, TableRow, Typography } from '@mui/material';
import { Button, Loading, LoaderSize } from 'framework/ui/mui-builder';
import { groupTailCellSx, tailCellSx, tailErrorSx } from './styles';
import { VirtualTableRowType } from './types';
import type { ListTableRow, VirtualTableRow } from './types';

interface ListTableTailRowProps<Row extends ListTableRow> {
  item: Extract<VirtualTableRow<Row>, { type: VirtualTableRowType.TAIL }>;
  columnCount: number;
  rowHeight: number;
}

const ListTableTailRow = <Row extends ListTableRow>({
  item: { group, loading },
  columnCount,
  rowHeight,
}: ListTableTailRowProps<Row>) => (
  <TableRow sx={{ height: rowHeight }}>
    <TableCell colSpan={columnCount} sx={group ? groupTailCellSx : tailCellSx}>
      {loading.retry && loading.error ? (
        <Box sx={tailErrorSx}>
          <Typography color="error">{loading.error}</Typography>
          <Button variant="text" size="small" onClick={loading.retry}>
            Retry
          </Button>
        </Box>
      ) : (
        <Loading size={LoaderSize.Medium} isInitialPosition />
      )}
    </TableCell>
  </TableRow>
);

export default ListTableTailRow;
